import moment = require("moment");
import * as React from "react";
// tslint:disable-next-line:no-implicit-dependencies
import {Subscription} from "rxjs";
import {Loader} from "../../../components/Utils/loader/Loader";
import {Popup} from "../dashboard/lavazza/components/popup/Popup";
import {PopupController} from "../dashboard/lavazza/components/popup/PopupController";
import {HaccpHeader} from "./components/HaccpHeader";
import {HaccpTable} from "./components/HaccpTable";
import {Record} from "./components/HaccpTableRow";
import {
    ceilFixed,
    DEFAULT_TIME_UNIT, DiagnosticType, EquipmentModel,
    HaccpConfiguration,
    HaccpController, LocationHaccpResponse,
    numberOfDays,
    setDefaultTemperatureUnit,
    UnitOfMeasure,
} from "./HaccpController";

import "./Haccp.scss";
import {ThemeProvider} from "@vebox/etui-system";
import {defaultTheme} from "@vebox/etui-themes";
import {veboxDefaultTheme} from "../../../index";
import {EmptyState, infoIcons} from "@vebox/etui-core";

export const HaccpPagePopupController: PopupController = new PopupController();

const TAB_BAR_PADDING = 39;

const DEFAULT_NUMBER_OF_RECORDS = 24;

declare var LOCALE: string;

export const cookieToMap = (cookieStr: string) => {
    const cookieStrs: string[] = cookieStr.split("; ");
    const result = {};
    cookieStrs.forEach((kvpair) => {
        const [key, value]: string[] = kvpair.split("=");
        result[key] = value;
    });
    return result;
};

export interface HaccpProps {
    equipmentID?: string;
    locationGuid?: string;
    texts: {
        header: {
            date: string,
            today: string,
            lastWeek: string,
            lastMonth: string,
            custom: string,
            from: string,
            to: string,
            legend: {
                legend: string,
                temperature: string,
                deviation: string,
                defrost: string,
                noData: string,
                off: string,
                high: string,
                low: string,
                edit: string,
            },
            extremesChipButtonLabel: string,
            exportLabel: string,
        },
        emptyPage: string,
        emptyPageSub: string,
        noHaccpReportAvailable: string,
        table: {
            diagnostics: string,
            low: string,
            high: string,
            editPopupTitle: string,
            createPopupTitle: string,
            editConfirmationButton: string,
            editPopupContent: string,
            createPopupContent: string,
            createConfirmationButton: string,
            configurationPopup: {
                cancelButtonText: string,
                maxLabel: string,
                minLabel: string,
                contentTypeLabel: string,
                thresholdLabel: string,
                warning: string,
                popupMinThresholdError: string,
                popupMaxThresholdError: string,
            };
            row: {
                max: string,
                avg: string,
                min: string,
                cell: {
                    lo: string,
                    hi: string,
                },
            }
            deletePopupContentQuestion1: string,
            deletePopupContentQuestion2: string,
            deletePopup: {
                title: string,
                confirm: string,
                cancel: string,
            }
        },
    };
}

export interface HaccpLocationSingleElement {
    configured: HaccpConfiguration[];
    unconfigured: DiagnosticType[];
    equipment: any;
    installationDate: string;
}

export interface HaccpState {
    haccpConfigs: HaccpConfiguration[];
    haccpNotConfig: DiagnosticType[];
    numberRecords: number;
    equipmentModel: EquipmentModel;
    empty: boolean;
    loading: boolean;
    isHaccpLocation?: boolean;
    haccpLocationSingleElements?: HaccpLocationSingleElement[];
    hasConfiguredProbes?: boolean;
}

export class Haccp extends React.Component<HaccpProps, HaccpState> {

    public static preprocessRecords = (records: Record[]) => {
        records.forEach((record) => {
            if (record) {
                record.lo = ceilFixed(record.lo, 1);
                record.hi = ceilFixed(record.hi, 1);
                record.mean = ceilFixed(record.mean, 1);
                record.max = ceilFixed(record.max, 1);
                record.min = ceilFixed(record.min, 1);
            }
        });
        return records;
    }

    private static EmptyPage = (text, sub) => {
        return (
            <EmptyState>
                <EmptyState.InfoIcon
                    glyph={infoIcons.NoContent}
                    styles={{
                        root: {
                            color: "var(--empty-indicator-svg-stroke)"
                        }
                    }}
                />
                <EmptyState.Title color="var(--empty-indicator-title-color)">{text}</EmptyState.Title>
                <EmptyState.SubTitle color="var(--empty-indicator-subtitle-color)">{sub}</EmptyState.SubTitle>
            </EmptyState>
        );
    }

    private haccpController: HaccpController;

    private sub: Subscription;

    constructor(props) {
        super(props);

        this.haccpController = new HaccpController();

        this.state = {
            haccpConfigs: [],
            haccpNotConfig: [],
            numberRecords: DEFAULT_NUMBER_OF_RECORDS,
            equipmentModel: null,
            empty: false,
            loading: false,
            haccpLocationSingleElements: [],
        };

        if (LOCALE === "en-US") {
            setDefaultTemperatureUnit(UnitOfMeasure.FAHRENHEIT);
        }
    }

    public componentDidMount() {
        (window as any).updateHACCPPanel = () => {
            this.updatePanelData(this.haccpController.getDateRange());
        };

        this.sub = this.haccpController.listenToDate(this.updatePanelData);

        this.haccpController.changeDate({
            start: moment().startOf(DEFAULT_TIME_UNIT).toDate(),
            end: moment().endOf(DEFAULT_TIME_UNIT).toDate(),
        });
    }

    public componentWillUnmount() {
        (window as any).updateHACCPPanel = null;
        this.sub.unsubscribe();
    }

    public render() {
        const tabBar = $(".entityFunctionsOptionsContainer");

        return (
            <ThemeProvider theme={veboxDefaultTheme}>
                <div
                    className={"wrapper"}
                    style={{
                        height: "100%",
                    }}
                >
                    {(this.state.empty && !this.state.loading && !this.state.hasConfiguredProbes)
                        ? null
                        : (
                            <div className={"header"}>
                                <HaccpHeader
                                    controller={this.haccpController}
                                    hasActiveConfigurations={
                                        this.state.hasConfiguredProbes
                                    }
                                    texts={this.props.texts.header}
                                    locationGuid={this.props.locationGuid}
                                />
                            </div>
                        )
                    }
                    <div
                        className={"main-container"}
                        style={{
                            overflow: "hidden",
                            width: "100%",
                            height: "100%",
                        }}
                    >
                        {(!this.state.haccpConfigs.length &&
                            !this.state.haccpNotConfig.length &&
                            !this.state.haccpLocationSingleElements.length)
                            ? !this.state.empty
                                ? <Loader/>
                                : Haccp.EmptyPage(this.props.texts.emptyPage, this.props.texts.noHaccpReportAvailable)
                            : <HaccpTable
                                controller={this.haccpController}
                                numberRecords={this.state.numberRecords}
                                configuration={this.state.haccpConfigs}
                                notConfigured={this.state.haccpNotConfig}
                                equipmentModel={this.state.equipmentModel}
                                texts={this.props.texts.table}
                                isHaccpLocation={this.state.isHaccpLocation}
                                locationHaccpSingleElements={this.state.haccpLocationSingleElements}
                                hasHaccpConfigs={this.state.hasConfiguredProbes}
                            />
                        }
                    </div>
                    <Popup controller={HaccpPagePopupController}/>
                </div>
            </ThemeProvider>
        );
    }

    private updatePanelData = (range: { start: Date, end: Date }) => {
        this.setState({
            haccpNotConfig: [],
            haccpConfigs: [],
            empty: false,
            loading: true,
        }, () => {
            if (this.props.equipmentID) {
                this.haccpController.getHaccpConfig(this.props.equipmentID, range.start, range.end)
                    .then(([haccpSupportedProbes, haccpConfigs, model]) => {
                        let haccpNotConfig = [];
                        const haccpExisting: HaccpConfiguration[] = [];

                        haccpConfigs.forEach((config) => {
                            const found = haccpSupportedProbes.find((diagnostic) => {
                                return diagnostic.guid === config.targetDiagnosticType.guid;
                            });
                            if (found) {
                                haccpExisting.push(config);
                            }
                        });

                        haccpConfigs = [...haccpExisting];

                        haccpSupportedProbes.forEach((supportedProbe) => {
                            let config = false;
                            haccpConfigs.forEach((haccpConfig) => {
                                if (supportedProbe.guid as string === haccpConfig.targetDiagnosticType.guid) {
                                    haccpConfig.name = supportedProbe.name;
                                    config = true;
                                }
                            });
                            if (!config) {
                                haccpNotConfig.push(supportedProbe);
                            }
                        });

                        haccpConfigs = haccpConfigs.sort((a, b) => {
                            return this.compareDiagnosticTypes(a.targetDiagnosticType, b.targetDiagnosticType);
                        });

                        haccpNotConfig = haccpNotConfig.sort((a, b) => {
                            return this.compareDiagnosticTypes(a, b);
                        });

                        const length = numberOfDays(range.end, range.start);

                        this.setState({
                            haccpConfigs,
                            haccpNotConfig,
                            numberRecords: haccpConfigs[0]
                                ? haccpConfigs[0].records.length
                                : length
                                    ? length
                                    : DEFAULT_NUMBER_OF_RECORDS,
                            equipmentModel: model,
                            empty: false,
                            loading: false,
                            hasConfiguredProbes: haccpConfigs[0] !== undefined,
                        });
                    }).catch(() => {
                    this.setState({
                        empty: true,
                        loading: false,
                    });
                });
            } else if (this.props.locationGuid) {
                this.haccpController.getHaccpConfigsByLocation(this.props.locationGuid, range.start, range.end)
                    .then((result) => {
                        const haccpConfigs = [];
                        const haccpNotConfig = [];
                        const equipments = [];
                        const haccpLocationSingleElementsResult: HaccpLocationSingleElement[] = [];
                        let hasConfigProbes: boolean = false;
                        let oldestInstallationDate: Date = new Date();

                        result.forEach((element) => {
                            const res = this.handleSingleEquipmentConfigs(element);
                            if (
                                new Date(Date.parse(element.installationDate.replace(/\[(.*)\]/, "")))
                                <
                                oldestInstallationDate
                            ) {
                                oldestInstallationDate = new Date(
                                    Date.parse(element.installationDate.replace(/\[(.*)\]/, "")),
                                );
                            }
                            if (!(res.unconfigured.length === 0 && res.configured.length === 0)) {
                                res.configured.sort((a, b) => {
                                    return this.compareDiagnosticTypes(a.targetDiagnosticType, b.targetDiagnosticType);
                                });
                                res.unconfigured.sort((a, b) => {
                                    return this.compareDiagnosticTypes(a, b);
                                });
                                haccpLocationSingleElementsResult.push(res);
                                equipments.push(res.equipment);
                                if (res.configured[0]) {
                                    hasConfigProbes = true;
                                }
                            }
                        });
                        this.haccpController.installationDate.next(oldestInstallationDate);
                        const length = numberOfDays(range.end, range.start);

                        this.setState({
                            haccpConfigs,
                            haccpNotConfig,
                            numberRecords: length
                                ? length
                                : DEFAULT_NUMBER_OF_RECORDS,
                            equipmentModel: (equipments[0]) ? equipments[0].model : undefined,
                            empty: (haccpLocationSingleElementsResult.length === 0),
                            loading: false,
                            isHaccpLocation: true,
                            haccpLocationSingleElements: haccpLocationSingleElementsResult,
                            hasConfiguredProbes: hasConfigProbes,
                        });
                    });
            }
        });
    }

    private handleSingleEquipmentConfigs(configurations: LocationHaccpResponse): HaccpLocationSingleElement {
        const haccpConfigs = configurations.configurations as HaccpConfiguration[];

        const haccpNotConfig = configurations.diagnosticTypes.filter((diagnostic) => {
            return haccpConfigs.find((configuration) => {
                return configuration.targetDiagnosticType.guid === diagnostic.guid;
            }) === undefined;
        });

        return {
            configured: haccpConfigs,
            unconfigured: haccpNotConfig,
            equipment: configurations.equipment,
            installationDate: undefined,
        };
    }

    private compareDiagnosticTypes(a: DiagnosticType, b: DiagnosticType) {
        if (!a.name || !b.name) {
            return -1;
        }
        return (a.order === b.order)
            ? a.name.localeCompare(b.name)
            : a.order - b.order;
    }
}
